import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Col, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import Label from 'reactstrap/lib/Label';
import ButtonRow from 'src/Components/ButtonRow';
import DataTable from 'src/Components/DataTable';
import { IList } from 'src/Components/DataTable/DataTable';
import EInput, { EButton } from 'src/Components/EInput';
import OpenArrow from 'src/Components/OpenArrow/OpenArrow';
import { IRegionExpensePrice, IRegionProductPrice } from 'src/Interfaces/AdminInterface';
import { IEBPExpenseType, IProduct } from 'src/Interfaces/TestInterface';
import { IRegion } from 'src/Interfaces/WellInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import { allOrNoneSelected, allOrNoneSelectedInternalProp, selectAllOrNoneInternalProp } from 'src/UtilityFunctions/SelectAllOrNone';


@inject("stores")
@observer
export class AdminRegionProductDetails extends React.Component {

    private AdminStore: AdminStore;
    private MessageStore: MessageStore;
    private UserStore: UserStore;
    private TenantStore: any;
    private regionProductDisposer: any;
    private regionExpenseDisposer: any;
    private productsDisposer: any;
    private expensesDisposer: any;
    public props: any;
    private regionPricesHeader: any = [
        "Product Name",
        "Primary Category",
        "Taxable",
        "Size",
        "Unit",
        "Specific Gravity",
        "Weight",
        "Cost",
        "Price"
    ];
    private regionExpenseHeader: any = [
        "Name",
        "Type",
        "Taxable",
        "Cost",
        "Price",
    ];

    private regionPricesHeaderButtons: any;
    private regionExpenseHeaderButtons: any;

    private blankRegionData = {
        headers: this.regionPricesHeader,
        rows: [],
    };

    private blankExpenseData = {
        headers: this.regionExpenseHeader,
        rows: [],
    };

    public state = {
        expenseData: this.blankExpenseData,
        expenseList: [] as IEBPExpenseType[],
        modal: false,
        modalDataSet: undefined as unknown as IList,
        modalExpenseDataSet: undefined as unknown as IList,
        newInventoryList: {
            expenseList: [] as boolean[], 
            productList: [] as boolean[],
        },
        productList: [] as IProduct[],
        region: new IRegion(),
        regionData: this.blankRegionData,
        regionExpenses: [] as IRegionExpensePrice[],
        regionProducts: [] as IRegionProductPrice[],
        selectedList: 'productList',
        showExpenses: false,
        showProducts: false,
    };
    

    constructor(props: any) {
        super(props);
        this.AdminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = this.props.stores.UserStore;
        this.TenantStore = this.props.stores.TenantStore;
        this.initializeHeaders();
    }

    private initializeHeaders = () => {
        this.regionPricesHeaderButtons = [
            undefined,
            undefined,
            {
                content: this.renderTaxableHeader('regionProducts'),
                type: 'render'
            },
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
        ];
    
        this.regionExpenseHeaderButtons = [
            undefined,
            undefined,
            {
                content: this.renderTaxableHeader('regionExpenses'),
                type: 'render'
            },
            undefined,
            undefined,
        ];
    }

    public componentDidMount() {
        this.createDisposers();
        this.refreshData();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        this.productsDisposer();
        this.expensesDisposer();
        this.regionExpenseDisposer();
        this.regionProductDisposer();
    }


    public createDisposers() {
        this.regionProductDisposer = observe(this.AdminStore, 'regionProductPrices', (change) => {
            this.setState({ 
                regionProducts: change.newValue
            }, () => {
                this.formatRegionPriceData();
            });
        });

        this.regionExpenseDisposer = observe(this.AdminStore, 'regionExpensePrices', (change) => {
            this.setState({
                regionExpenses: change.newValue
            }, () => {
                this.formatRegionExpenseData();
            });
        });

        this.productsDisposer = observe(this.AdminStore, 'products', (change) => {
            const productList = change.newValue.filter(pl => !this.state.regionProducts.some(rp => rp.productId === pl.id));
            this.setState({
                productList
            }, () => {
                this.formatModalDataTable();
            });
        });

        this.expensesDisposer = observe(this.AdminStore, 'expenseTypes', (change) => {
            const expenseList = change.newValue.filter(pl => !this.state.regionExpenses.some(rp => rp.expenseId === pl.id));
            this.setState({
                expenseList
            }, () => {
                this.formatModalExpenseDataTable();
            });
        });
    }


    private refreshData = () => {
        const regionId = this.props.match.params.id;
        if (regionId !== 'new') {
            this.AdminStore.getRegion(regionId)
                .then(region => {
                    if (this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Read')) {

                        this.AdminStore.getRegionExpenses(regionId);
                        this.AdminStore.getRegionProducts(regionId)
                            .then(regionProducts => {
                                this.AdminStore.getProducts();
                                this.AdminStore.getExpenseTypes();
                                this.setState({region});
                            });
                    } else {
                        this.setState({region});
                    }
                });
        }
    }

    private toggleModal = (listName?:string) => () => {
        
        if(listName) {
            this.setState({
                modal: !this.state.modal,
                selectedList: listName,
            });
        } else {
            this.setState({
                modal: !this.state.modal,
            });
        }
    }

    private toggleList = (toggleName:string) => () => {
        this.setState({
            [toggleName]: !this.state[toggleName]
        });
    }
    private updateRegion = (event: any) => {
        const region = this.state.region;
        region[event.target.name] = event.target.value;
        this.setState({ region });
    }

    private saveRegion = (event: any) => {
        let regionRequest: Promise<any>;
        if (this.state.region.id === '') {
            regionRequest = this.AdminStore.postRegion(this.state.region);
        } else {
            regionRequest = this.AdminStore.putRegion(this.state.region);
        }

        regionRequest.then(regionId => {
            const region = this.state.region;
            if (region.id !== '') {
                this.saveRegionPrices();
            } else {
                region.id = regionId;
                this.AdminStore.getRegionExpenses(region.id);
                this.AdminStore.getRegionProducts(region.id)
                    .then(regionProducts => {
                        this.setState({ region, regionProducts }, () => this.formatRegionPriceData());
                        this.props.history.replace('/admin/regions/' + region.id);
                    });
            }

        });

    }

    private handlePriceChange = (listName: string, index: number) => (event: any) => {
        const regionProducts = this.state[listName];
        regionProducts[index].price = event.target.value;
        this.setState({ [listName]: regionProducts });
    }

    private handleCostChange = (listName: string, index: number) => (event: any) => {
        const regionProducts = this.state[listName];
        regionProducts[index].cost = event.target.value;
        this.setState({ [listName]: regionProducts });
    }

    private handleTaxableClick = (listName: string, index: number) => (event: any) => {
        const regionProducts = this.state[listName];
        regionProducts[index].isTaxable = !regionProducts[index].isTaxable;
        this.setState({ [listName]: regionProducts });
    }

    private allOrNoneSelectedPrices = (isAll: boolean, listName: string, propName: string) => {
        const elements: any[] = this.state[listName];
        return allOrNoneSelectedInternalProp(isAll, elements, propName);
    }

    private selectAllOrNonePrices = (value: boolean, listName: string, propName: string) => () => {
        const elements: any[] = this.state[listName];
        selectAllOrNoneInternalProp(value, elements, propName);
        this.setState({[listName]: elements});
    }

    private renderTaxableHeader = (listName: string) => () => {
        const hasRegionInventoryUpdate = this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Update');
        return (
            <div>
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelectedPrices(true, listName, 'isTaxable')}
                    onClick={this.selectAllOrNonePrices(true, listName, 'isTaxable')}
                    disabled={!hasRegionInventoryUpdate}
                >
                    All
                </Button>
                {' '}
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelectedPrices(false, listName, 'isTaxable')}
                    onClick={this.selectAllOrNonePrices(false, listName, 'isTaxable')}
                    disabled={!hasRegionInventoryUpdate}
                >
                    None
                </Button>
            </div>
        );
    }

    private selectAllOrNone = (value: boolean, listName: string) => () => {
        const newInventoryList = this.state.newInventoryList;
        newInventoryList[listName] = new Array(this.state[listName].length).fill(value);
        this.setState({newInventoryList});
    }
    private allOrNoneSelected = (value: boolean, listName: string) => {
        return allOrNoneSelected(value, listName, `newInventoryList.${listName}`, this.state);
    }
    private renderSelectionButons = (listName: string) => {
        

        return (
            <div style={{marginBottom: '1rem'}}>
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelected(true, listName)}
                    onClick={this.selectAllOrNone(true, listName)}
                >
                    All
                </Button>
                {' '}
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelected(false, listName)}
                    onClick={this.selectAllOrNone(false, listName)}
                >
                    None
                </Button>
            </div>
        );
    }


    private renderPriceInput = (listName: string, regionPrice: IRegionProductPrice | IRegionExpensePrice, index: number) => () => {
        const hasRegionInventoryUpdate = this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Update');

        return (
            <Input
                key={`${listName}-${regionPrice.id}`}
                type="text"
                name={`${listName}-Price-${regionPrice.id}`}
                id={`${listName}-Price-${regionPrice.id}`}
                value={regionPrice.price}
                onChange={this.handlePriceChange(listName, index)}
                disabled={!hasRegionInventoryUpdate}
            />
        );
    }

    private renderCostInput = (listName: string, regionPrice: IRegionProductPrice | IRegionExpensePrice, index: number) => () => {
        const hasRegionInventoryUpdate = this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Update');

        return (
            <Input
                key={`${listName}-${regionPrice.id}`}
                type="text"
                name={`${listName}-Cost-${regionPrice.id}`}
                id={`${listName}-Cost-${regionPrice.id}`}
                value={regionPrice.cost}
                onChange={this.handleCostChange(listName, index)}
                disabled={!hasRegionInventoryUpdate}
            />
        );
    }

    private renderTaxableCheckbox = (listName: string, regionPrice: IRegionProductPrice | IRegionExpensePrice, index: number) => () => {
        const hasRegionInventoryUpdate = this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Update');

        return (
            <div className="multi-select-row">
                <Input 
                    key={`${listName}-${regionPrice.id}`}
                    onChange={this.handleTaxableClick(listName, index)}
                    checked={regionPrice.isTaxable}
                    type="checkbox"
                    value=""
                    disabled={!hasRegionInventoryUpdate}
                />
            </div>
        );
    }

    private saveRegionPrices = () => {
        const saveDataPromise = [
            this.AdminStore.postRegionProducts(this.state.region.id, this.state.regionProducts),
            this.AdminStore.postRegionExpenses(this.state.region.id, this.state.regionExpenses),
        ];

        Promise.all(saveDataPromise)
            .then(regionPrices => {
                if (Array.isArray(regionPrices) && regionPrices[0] && regionPrices[1]) {
                    this.MessageStore.addMessage('Changes Have Been Saved', 'success');
                    this.refreshData();
                }
            });
    }
    private handlePriceDelete = ( listName: string ) => (index: number) => {
        const regionProducts = this.state[listName];
        regionProducts.splice(index, 1);
        this.setState({ [listName]: regionProducts }, () => {
            switch (listName) {
                case 'regionProducts':
                    this.formatRegionPriceData();
                    break;
                case 'regionExpenses':
                    this.formatRegionExpenseData();
                    break;
                default:
                    break;
            }
            
        });
    }

    private deleteRegion = () => {
        const areYouSure = confirm(
            `Deleting this Region will remove all Price Lists associated with this Region.\n\n`
            + `Are you sure you want to remove the Region: ${this.state.region.name}?\n\n`
            + `Press OK to delete.`
        );
        if (areYouSure) {
            this.AdminStore.deleteRegion(this.state.region.id)
                .then(data => {
                    if (data) {
                        this.MessageStore.addMessage('Region Deleted.', 'success');
                        this.props.history.push('/admin/products');
                    }
                });
        }
    }

    private formatModalDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Product',
            'Category',
            'Unit',
            'Size',
            'SG',
            'Weight',
            'Price'
        ];
        if (this.state.productList) {
            this.state.productList.map((product: IProduct, index: number) => {
                const newObject = [
                    {
                        content: product.name
                    },
                    {
                        content: product.categorys[0].name
                    },
                    {
                        content: product.unit
                    },
                    {
                        content: product.size
                    },
                    {
                        content: product.specificGravity
                    },
                    {
                        content: product.weight
                    },
                    {
                        content: product.retailPrice
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            modalDataSet: listStructure
        });
    }

    private formatModalExpenseDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Name',
            'Type',
            'Cost',
            'Price',
        ];
        if (this.state.expenseList) {
            this.state.expenseList.map((expense: IEBPExpenseType, index: number) => {
                const newObject = [
                    {
                        content: expense.name
                    },
                    {
                        content: expense.isRental ? 'Rental' : 'Service'
                    },
                    {
                        content: expense.cost
                    },
                    {
                        content: expense.retailPrice
                    },
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            modalExpenseDataSet: listStructure,
        });
    }



    private formatRegionPriceData = () => {
        const regionPrices = this.state.regionProducts;

        const rows: any = [];

        regionPrices.forEach((regionPrice, index) => {
            const tempRow = [
                {
                    content: regionPrice.name
                },
                {
                    content: regionPrice.category
                },
                {
                    content: this.renderTaxableCheckbox('regionProducts', regionPrice, index),
                    sortItem: regionPrice.isTaxable,
                    type: 'render',
                },
                {
                    content: regionPrice.size
                },
                {
                    content: regionPrice.unit
                },
                {
                    content: regionPrice.specificGravity
                },
                {
                    content: regionPrice.weight
                },
                {
                    content: this.renderCostInput('regionProducts', regionPrice, index),
                    sortItem: regionPrice.cost,
                    type: 'render',
                },
                {
                    content: this.renderPriceInput('regionProducts', regionPrice, index),
                    sortItem: regionPrice.price,
                    type: 'render'
                }
            ];

            rows.push(tempRow);
        });

        this.setState({ regionData: { headers: this.regionPricesHeader, rows } });
    }

    private formatRegionExpenseData = () => {
        const formattedData: any[] = [];
        this.state.regionExpenses.map((expense: IRegionExpensePrice, index: number) => {
            const row = [
                {
                    content: expense.name,
                },
                {
                    content: expense.isRental === true ? 'Rental' : 'Service'
                },
                {
                    content: this.renderTaxableCheckbox('regionExpenses', expense, index),
                    sortItem: expense.isTaxable,
                    type: 'render',
                },
                {
                    content: this.renderCostInput('regionExpenses', expense, index),
                    sortItem: expense.cost,
                    type: 'render',
                },
                {
                    content: this.renderPriceInput('regionExpenses', expense, index),
                    sortItem: expense.price,
                    type: 'render'
                }
            ];
            formattedData.push(row);
        });

        this.setState({
            expenseData: {
                headers: this.regionExpenseHeader,
                rows: formattedData
            }
        });
    }

    private handleMultiSelect = (listName:string) => (index: number) => {
        const newInventoryList = this.state.newInventoryList;
        const newSelections = newInventoryList[listName];
        newSelections[index] = !newSelections[index];
        this.setState({newInventoryList});
    }

    private handleSave = (listName: string) => () => {
        switch (listName) {
            case 'productList':
                this.handleSaveProducts();
                break;
            case 'expenseList':
                this.handleSaveExpenses();
                break;
            default:
                console.error(`There is no ${listName} list`);
                break;
        }
    }

    private handleSaveExpenses = () => {
        const regionExpenses = this.state.regionExpenses;
        const expenseList = this.state.expenseList;
        const removeList: number[] = [];
        expenseList.forEach((expense, index) => {
            if(this.state.newInventoryList.expenseList[index]) {
                const newRegionExpense: IRegionExpensePrice = {
                    cost: expense.cost,
                    expenseId: expense.id,
                    id: '',
                    isRental: expense.isRental,
                    isTaxable: expense.isTaxable,
                    name: expense.name,
                    price: expense.retailPrice,
                    regionId: this.state.region.id,
                };
                regionExpenses.push(newRegionExpense);
                removeList.unshift(index);
            }
        });
        removeList.forEach(value => {
            expenseList.splice(value, 1);
        });

        regionExpenses.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });

        this.setState({
            expenseList,
            isDirty: true,
            modal: false,
            regionExpenses,
        }, () => {
            this.formatModalExpenseDataTable();
            this.formatRegionExpenseData();
        });
    }

    private handleSaveProducts = () => {
        const regionProducts = this.state.regionProducts;
        const productList = this.state.productList;
        const removeList: number[] = [];
        productList.forEach((product, index) => {
            if (this.state.newInventoryList.productList[index]) {
                const newRegionPrice: IRegionProductPrice = {
                    category: '',
                    cost: product.cost ? product.cost : 0,
                    id: '',
                    isTaxable: product.isTaxable,
                    name: product.name,
                    price: product.retailPrice,
                    productId: product.id,
                    regionId: this.state.region.id,
                    size: product.size,
                    specificGravity: product.specificGravity,
                    unit: product.unit,
                    weight: product.weight,
                };
                regionProducts.push(newRegionPrice);
                removeList.unshift(index);
            }
        });

        removeList.forEach(value => {
            productList.splice(value, 1);
        });

        regionProducts.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });

        this.setState({
            isDirty: true,
            modal: false,
            productList,
            regionProducts,
        }, () => {
            this.formatModalDataTable();
            this.formatRegionPriceData();
        });
    }

    private disabledRegionDetails = () => {
        return (
            (this.state.region.id === '' && !this.UserStore.hasPermission('Permissions.Admin.Regions.Create'))
            || (this.state.region.id !== '' && !this.UserStore.hasPermission('Permissions.Admin.Regions.Update'))
        );
    }

    public render() {
        const hasRegionInventoryDelete = this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Delete');
        const hasRegionInventoryCreate = this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Create');
        const hasRegionInventoryRead = this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Read');
        const hasRegionInventoryUpdate = this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Update');

        return <div>
            <Row>
                <Col>
                    <h4>Region Details</h4>
                </Col>
            </Row>
            <Row>
                <Col md="6">
                    <FormGroup className="required">
                        <Label>
                            Region Name
                        </Label>
                        <EInput
                            type="text"
                            name="name"
                            id="name"
                            value={this.state.region.name}
                            onChange={this.updateRegion}
                            required={true}
                            disabled={this.disabledRegionDetails()}
                        />
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup className="required">
                        <Label>State</Label>
                        <EInput
                            type="select"
                            name="state"
                            id="state"
                            value={this.state.region.state}
                            onChange={this.updateRegion}
                            disabled={this.disabledRegionDetails()}
                            required={true}
                        >
                            <option disabled={true} />
                            <option value="OK">Oklahoma</option>
                            <option value="NM">New Mexico</option>
                            <option value="TX">Texas</option>
                        </EInput>
                    </FormGroup>
                </Col>
            </Row>
            {   this.state.region.id !== '' && 
                hasRegionInventoryRead &&
                <React.Fragment>
                    <Row>
                        <Col>
                            <h4 onClick={this.toggleList('showProducts')}><OpenArrow color={this.TenantStore.iconColor} open={this.state.showProducts} />Region Product List</h4>
                        </Col>
                    </Row>
                {   this.state.showProducts &&
                    <Row>
                        <Col>
                            <DataTable
                                list={this.state.regionData}
                                onDelete={hasRegionInventoryDelete ? this.handlePriceDelete('regionProducts') : undefined}
                                headerButtons={this.regionPricesHeaderButtons}
                                maxHeight='55vh'
                            />
                        </Col>
                    </Row>
                }
                    <Row>
                        <Col>
                            <h4 onClick={this.toggleList('showExpenses')}><OpenArrow color={this.TenantStore.iconColor} open={this.state.showExpenses} />Region EBP List</h4>
                        </Col>
                    </Row>
                {   this.state.showExpenses &&
                    <Row>
                        <Col>
                            <DataTable
                                list={this.state.expenseData}
                                onDelete={hasRegionInventoryDelete ? this.handlePriceDelete('regionExpenses') : undefined}
                                headerButtons={this.regionExpenseHeaderButtons}
                                maxHeight='55vh'
                            />
                        </Col>
                    </Row>
                }
                </React.Fragment>
            }
            <ButtonRow>
                {
                    this.state.region.id !== '' &&
                    this.UserStore.hasPermission('Permissions.Admin.Regions.Delete') &&
                    <Button color="danger" onClick={this.deleteRegion}>Delete Region</Button>
                }
                {' '}
                {
                    this.state.region.id !== '' &&
                    this.UserStore.hasPermission('Permissions.Admin.Inventory.Create') &&
                    <Link to='/admin/products/new'>
                        <Button color="primary">Create New Product</Button>
                    </Link>
                }
                {' '}
                {
                    this.state.region.id !== '' &&
                    hasRegionInventoryCreate &&
                    <Button color="primary" onClick={this.toggleModal('productList')}>Assign Products to Region</Button>
                }
                {
                    this.state.region.id !== '' &&
                    hasRegionInventoryCreate &&
                    <Button color="primary" onClick={this.toggleModal('expenseList')}>Assign EBP to Region</Button>
                }
                {
                    this.state.region.id !== '' &&
                    !this.UserStore.hasPermission('Permissions.Admin.Regions.Update')
                    && (
                        hasRegionInventoryCreate
                        || hasRegionInventoryDelete
                        || hasRegionInventoryUpdate
                    )
                    &&
                    <Button color="primary" onClick={this.saveRegionPrices}>Save Region Inventory</Button>
                }
                {
                    (this.state.region.id === '' ?
                    this.UserStore.hasPermission('Permissions.Admin.Regions.Create')
                    :
                    this.UserStore.hasPermission('Permissions.Admin.Regions.Update'))
                    &&
                    <EButton color="primary" onClick={this.saveRegion}>{this.state.region.id === '' ? 'Add New Region' : 'Save Region'}</EButton>
                }
            </ButtonRow>
            <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal()} size="lg">
                <ModalHeader toggle={this.toggleModal()}>{ this.state.selectedList === 'productList' ? 'Product List' : 'EBP List' }</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="12">
                            {this.renderSelectionButons(this.state.selectedList)}
                            <DataTable
                                list={this.state.selectedList === 'productList' ? this.state.modalDataSet : this.state.modalExpenseDataSet}
                                onMultiSelect={this.handleMultiSelect(this.state.selectedList)}
                                multiSelectChecked={this.state.newInventoryList[this.state.selectedList]}
                            />
                        </Col>
                    </Row>
                    {/* 
                        MUD-2025  Archive the user defined product feature so comment for now.
                        This can be removed later if the feature is removed.
                        <div className="add-table-row">
                            <Button className="primary add-new-button" onClick={this.toggleProductModal}>
                                        <FontAwesomeIcon icon="plus" />
                                        { ' User Defined Product' }
                            </Button>
                        </div> */}
                </ModalBody>
                <ModalFooter>
                    <Button className="secondary" onClick={this.toggleModal()}>Cancel</Button>
                    <Button color="primary" onClick={this.handleSave(this.state.selectedList)}>Add to Region List</Button>
                </ModalFooter>
            </Modal>
        </div>;
    }
}

export default withRouter(AdminRegionProductDetails);


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Products/AdminRegionProductDetails.tsx